export function 表示用日付(日付: string|null): string {
  if (日付 === null || 日付.length === 0) {
    return '';
  } else {
    return 日付.replace(/-/g, '/');
  }
}
